import Loadable from 'react-loadable';

export const FollowGoalAction = Loadable({
  loader: () => import(/* webpackChunkName: "FollowGoalAction" */ './FollowGoalAction'),
  loading: () => null,
});

export { followGoalResource } from './resource';
